import { IMaterial } from 'src/interfaces/news';

export const createListRenderer = (
  list: IMaterial[],
  map: (m: IMaterial, idx: number) => JSX.Element,
  injectConfig?: Record<number, React.ReactNode>,
) => {
  return list.map((material, idx) => (
    <>
      {map(material, idx)}

      {injectConfig?.[idx]}
    </>
  ));
};
